import { render, staticRenderFns } from "./noMenuTpl.vue?vue&type=template&id=dc30b758&"
import script from "./noMenuTpl.vue?vue&type=script&lang=js&"
export * from "./noMenuTpl.vue?vue&type=script&lang=js&"
import style0 from "./noMenuTpl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports